import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bgcolor: 'white',
    user: {
      username: '',
      password: ''
    },
    messages: [],
    userid: ''
  },
  mutations: {
    UPDATE_MESSAGES: function(state, payload) {
      state.messages = payload
    },
    UPDATE_USERID: function(state, payload) {
      state.userid = payload
    }
  },
  actions: {
    sendMessage: async function({ state, commit }, { message, messages, userid }) {
      var vm = this
      if (message && message.payload.trim() !== '') {
        var data = {
          pageid: process.env.VUE_APP_PAGE_ID,
          userid: userid,
          message: { data: message.payload.trim(), type: 'text' }
        }

        const response = await axios.post(
          'https://communitybotbyzwizai.herokuapp.com/webhookwebchat',
          data,
          {
            headers: {
              Authorization: 'Bearer r313p6JWgEUv5Jd87UbxV9Ddos35j7gt'
            }
          }
        )
        if (response.data.responsecode == 200) {
          if (response.data.data && response.data.data.length) {
            return {
              quick_replies: response.data.quick_replies
                ? response.data.quick_replies.split(',')
                : '',
              messages: response.data.data
            }
          } else {
            return {
              quick_replies: [],
              messages: []
            }
          }
        } else {
          vm.$swal.fire({
            icon: 'error',
            text: response.data.responsecode
          })
          return false
        }
      } else {
        return false
      }
    }
  },
  modules: {}
})
